export class RepairEligResponse {
  public statusCode: number;
  public decision: boolean;
}
